/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Partner_Referral_Stat_PendingInputs */



/**
* | output |
* | --- |
* | "{count} signup in progress" |
*
* @param {Partner_Referral_Stat_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_referral_stat_pending = /** @type {((inputs: Partner_Referral_Stat_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Referral_Stat_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Registrierung läuft`)
	return /** @type {LocalizedString} */ (`${i?.count} signup in progress`)
});